(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3661],{

/***/ 66678:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseClone = __webpack_require__(85990);

/** Used to compose bitmasks for cloning. */
var CLONE_SYMBOLS_FLAG = 4;

/**
 * Creates a shallow clone of `value`.
 *
 * **Note:** This method is loosely based on the
 * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
 * and supports cloning arrays, array buffers, booleans, date objects, maps,
 * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
 * arrays. The own enumerable properties of `arguments` objects are cloned
 * as plain objects. An empty object is returned for uncloneable values such
 * as error objects, functions, DOM nodes, and WeakMaps.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to clone.
 * @returns {*} Returns the cloned value.
 * @see _.cloneDeep
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var shallow = _.clone(objects);
 * console.log(shallow[0] === objects[0]);
 * // => true
 */
function clone(value) {
  return baseClone(value, CLONE_SYMBOLS_FLAG);
}

module.exports = clone;


/***/ }),

/***/ 63661:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Stores; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-icons/md/index.esm.js
var index_esm = __webpack_require__(5434);
// EXTERNAL MODULE: ./node_modules/@packages/justo-parts/lib/components/Container/index.js
var Container = __webpack_require__(59848);
// EXTERNAL MODULE: ./node_modules/@packages/justo-parts/lib/components/Tooltip/index.js
var Tooltip = __webpack_require__(34053);
// EXTERNAL MODULE: ./src/components/SuspenseLoading/Loading.tsx
var Loading = __webpack_require__(53762);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
// EXTERNAL MODULE: ./src/providers/apollo/getClient.ts
var apollo_getClient = __webpack_require__(98751);
// EXTERNAL MODULE: ./node_modules/graphql-tag/lib/index.js + 1 modules
var lib = __webpack_require__(50456);
;// CONCATENATED MODULE: ./src/data/queries/components/placeDetail.ts
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}

function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  query getPlaceDetails_cached($placeId: ID) {\n    place(placeId: $placeId) {\n      _id\n      text\n      secondaryText\n      location\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var placeDetailQuery = (0,lib["default"])(_templateObject());
function getPlaceDetail(placeId) {
    return _getPlaceDetail.apply(this, arguments);
};
function _getPlaceDetail() {
    _getPlaceDetail = _asyncToGenerator(regeneratorRuntime.mark(function _callee(placeId) {
        var data;
        return regeneratorRuntime.wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return getClient().query({
                        query: placeDetailQuery,
                        variables: {
                            placeId: placeId
                        }
                    });
                case 2:
                    data = _ctx.sent.data;
                    return _ctx.abrupt("return", data.place);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _getPlaceDetail.apply(this, arguments);
}

// EXTERNAL MODULE: ./src/helpers/misc/isMobile.ts
var isMobile = __webpack_require__(58406);
// EXTERNAL MODULE: ./src/helpers/misc/isServerSide.ts
var isServerSide = __webpack_require__(90257);
// EXTERNAL MODULE: ./node_modules/apollo-hooks/dist/apollo-hooks.es.js
var apollo_hooks_es = __webpack_require__(3172);
// EXTERNAL MODULE: ./src/components/componentTypes/Stores/Address/styles.module.css
var styles_module = __webpack_require__(18000);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/components/componentTypes/Stores/Address/index.tsx










function Address(param) {
    var placeId = param.placeId, ssrAddress = param.ssrAddress;
    var ref = (0,apollo_hooks_es/* useApolloQuery */.Zu)({
        query: placeDetailQuery,
        variables: {
            placeId: placeId
        },
        partial: true,
        omit: (0,isServerSide/* default */.Z)()
    }), queriedPlace = ref.place;
    var place = queriedPlace ? queriedPlace : ssrAddress;
    if ((0,isServerSide/* default */.Z)() && !ssrAddress) {
        console.warn("Could not fetch place while doing SSR. This should be fixed for an optimized experience");
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading/* default */.Z, {});
    }
    var onClick = function() {
        var url = "https://www.google.com/maps/search/?api=1&query=Google&query_place_id=".concat(placeId);
        if (isMobile/* default */.Z) {
            window.location.href = url;
        } else {
            window.open(url);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (styles_module_default()).container,
        onClick: onClick,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Tooltip["default"], {
            content: "Abrir en Google Maps",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* MdDirections */.YsQ, {
                    style: {
                        marginRight: 8,
                        top: -1,
                        position: "relative"
                    }
                }),
                place ? place.text : "Cargando..."
            ]
        })
    });
};

// EXTERNAL MODULE: ./src/hooks/useResizedImageURL.ts
var useResizedImageURL = __webpack_require__(25447);
// EXTERNAL MODULE: ./src/components/componentTypes/Stores/Image/styles.module.css
var Image_styles_module = __webpack_require__(63629);
var Image_styles_module_default = /*#__PURE__*/__webpack_require__.n(Image_styles_module);
;// CONCATENATED MODULE: ./src/components/componentTypes/Stores/Image/index.tsx






function Image(props) {
    var ref, ref1;
    var file = props.file;
    var queriedUrl = (0,useResizedImageURL/* default */.Z)({
        fileId: file ? file._id : null,
        width: 500,
        height: 300
    }, {
        partial: true
    });
    var url = queriedUrl ? queriedUrl : (ref = props.ssrImage) === null || ref === void 0 ? void 0 : ref.resizedURL;
    if ((0,isServerSide/* default */.Z)() && !((ref1 = props.ssrImage) === null || ref1 === void 0 ? void 0 : ref1.resizedURL)) {
        console.warn("Could not fetch store image while doing SSR. This should be fixed for an optimized experience");
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading/* default */.Z, {});
    }
    if (!file) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
        className: (Image_styles_module_default()).image,
        src: url,
        alt: ""
    });
};

// EXTERNAL MODULE: ./src/components/componentTypes/Stores/Text/styles.module.css
var Text_styles_module = __webpack_require__(76942);
var Text_styles_module_default = /*#__PURE__*/__webpack_require__.n(Text_styles_module);
;// CONCATENATED MODULE: ./src/components/componentTypes/Stores/Text/index.tsx



function Text(props) {
    if (!props.store.otherText) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (Text_styles_module_default()).container,
        children: props.store.otherText.split("\n").map(function(line, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                children: [
                    line,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                ]
            }, index);
        })
    });
};

// EXTERNAL MODULE: ./src/components/componentTypes/Stores/styles.module.css
var Stores_styles_module = __webpack_require__(46054);
var Stores_styles_module_default = /*#__PURE__*/__webpack_require__.n(Stores_styles_module);
;// CONCATENATED MODULE: ./src/components/componentTypes/Stores/index.tsx









function Stores(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (Stores_styles_module_default()).container,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
            children: [
                props.title ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (Stores_styles_module_default()).title,
                    children: props.title
                }) : null,
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "row center-xs",
                    children: props.stores.map(function(store, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-xs-12 col-sm-6 col-md-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (Stores_styles_module_default()).store,
                                children: [
                                    store.image ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                        file: store.image,
                                        ssrImage: props.ssrImages && props.ssrImages[index]
                                    }) : null,
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (Stores_styles_module_default()).inner,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (Stores_styles_module_default()).name,
                                                children: store.name
                                            }),
                                            store.phone ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (Stores_styles_module_default()).phone,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Tooltip["default"], {
                                                    content: "Llamar",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* MdPhone */.IXo, {
                                                            style: {
                                                                marginRight: 8,
                                                                top: -1,
                                                                position: "relative"
                                                            }
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            href: "tel:" + encodeURIComponent(store.phone),
                                                            children: store.phone
                                                        })
                                                    ]
                                                })
                                            }) : null,
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Address, {
                                                placeId: store.placeId,
                                                ssrAddress: props.ssrAddresses && props.ssrAddresses[index]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                                                store: store
                                            })
                                        ]
                                    })
                                ]
                            })
                        }, index);
                    })
                })
            ]
        })
    });
};


/***/ }),

/***/ 6909:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ HasWebpSupport; }
/* harmony export */ });
/* harmony import */ var _helpers_misc_isServerSide__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(90257);

var result = null;
// https://stackoverflow.com/questions/5573096/detecting-webp-support
function HasWebpSupport() {
    if (result !== null) {
        return result;
    }
    if ((0,_helpers_misc_isServerSide__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)()) return true;
    result = false;
    var elem = document.createElement("canvas");
    if (elem.getContext && elem.getContext("2d")) {
        // was able or not to get WebP representation
        try {
            result = elem.toDataURL("image/webp").indexOf("data:image/webp") == 0;
        } catch (e) {
            result = false;
        }
    }
    // very old browser like IE 8, canvas not supported
    return result;
};


/***/ }),

/***/ 58406:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var regexp = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
/* harmony default export */ __webpack_exports__["Z"] = (typeof navigator !== "undefined" && regexp.test(navigator.userAgent));


/***/ }),

/***/ 25447:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useResizedImageURL; }
/* harmony export */ });
/* harmony import */ var _helpers_misc_hasWebpSupport__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6909);
/* harmony import */ var _helpers_misc_isServerSide__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(90257);
/* harmony import */ var apollo_hooks__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3172);
/* harmony import */ var graphql_tag__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(50456);
/* harmony import */ var lodash_clone__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66678);
/* harmony import */ var lodash_clone__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_clone__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _useLocalStorageState__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(54501);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n      query getResizedImage(\n        $fileId: ID\n        $scale: Float\n        $width: Float\n        $height: Float\n        $resizeMode: ID\n        $background: String\n        $format: String\n      ) {\n        image(fileId: $fileId) {\n          _id\n          resizedURL(\n            scale: $scale\n            width: $width\n            height: $height\n            resizeMode: $resizeMode\n            background: $background\n            format: $format\n          )\n        }\n      }\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}






function useResizedImageURL(opt) {
    var queryOpts = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var options = lodash_clone__WEBPACK_IMPORTED_MODULE_1___default()(opt);
    if (options.format !== "jpeg" && (0,_helpers_misc_hasWebpSupport__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)()) {
        options.format = "webp";
    }
    var cacheKey = "resizedImage.".concat(JSON.stringify(options));
    var cachedResult = (0,_helpers_misc_isServerSide__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)() ? null : (0,_useLocalStorageState__WEBPACK_IMPORTED_MODULE_2__/* .localStorageGetItem */ .G)(cacheKey);
    var image = (0,apollo_hooks__WEBPACK_IMPORTED_MODULE_0__/* .useApolloQuery */ .Zu)(_objectSpread({
        query: (0,graphql_tag__WEBPACK_IMPORTED_MODULE_5__["default"])(_templateObject()),
        variables: options,
        omit: !!cachedResult || !options.fileId || (0,_helpers_misc_isServerSide__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)()
    }, queryOpts)).image;
    if (!options.fileId) return null;
    if (cachedResult) return cachedResult;
    if (!image) return null;
    localStorage === null || localStorage === void 0 ? void 0 : localStorage.setItem(cacheKey, image.resizedURL);
    return image.resizedURL;
};


/***/ }),

/***/ 18000:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"_3ii9Qu0O-VJP71DV4UsUaJ"};

/***/ }),

/***/ 63629:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"image":"mXOHOcEP-km4ecwokXNZk"};

/***/ }),

/***/ 76942:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"ImcWw1s_dggNnyVyEKRr7"};

/***/ }),

/***/ 46054:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"_2ec3xE14BqiBrJJ9TRHE_f","title":"_1-FZlDa7-4_pNydFYBeTGW appSubtitle","store":"_3UY6HjuODNGgZrDtEKi_XX content","inner":"_3mNMV5yR1jP_OzD9a7N-ph","name":"_1Y-ueg6dtL1Fme8Lxax_bU","phone":"_3Rqe5nGznJnI-dq_wZTrNR"};

/***/ })

}]);